import { Card, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import qs from 'qs'; // You can install this with `npm install qs`
import Button from 'components/base/Button';

interface SearchCoachSidebarProps {
  className?: string;
  onSearchComplete: (data: any) => void;
}


const SearchCoachSidebar = ({ className, onSearchComplete }: SearchCoachSidebarProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  const [isCoach, setIsCoach] = useState(true);
  const [isCoachInterno, setIsCoachInterno] = useState(true);


  type MapType = Map<string, string>;
  const [searchMap, setSearchMap] = useState<MapType>(new Map());

  // Function to handle select changes
  const handleSelectInputChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name } = e.target;
    const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
    console.log(name + " " + selectedValues)
    updateMap(name, selectedValues.join(", "));
  };

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateMap(name, value);
  };

  const updateMap = (key: string, value: string) => {
    setSearchMap(prevMap => {
      const newMap = new Map(prevMap);
      newMap.set(key, value);
      return newMap;
    });
  };

  // Function to convert map to object
  const mapToObject = (map: MapType): Record<string, string> => {
    const obj: Record<string, string> = {};
    map.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  };

  const handleSearch = async () => {

    const params = mapToObject(searchMap);
    params['isCoach'] = isCoach ? '1' : '0';
    params['isCoachInterno'] = isCoachInterno ? '1' : '0';
    const queryString = qs.stringify(params);
    console.log(queryString);
    try {
      const response = await apiClient.get(
        `/v1/find/coach?${queryString}`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',

          }
        }
      );
      onSearchComplete(response.data);
    } catch (error) {
      console.error('Request failed:', error);
    }

  };

  return (
    <Card className={className}>
      <Card.Body>
        <h4 className="mb-4">{t("SearchCoachSidebar.search")}</h4>
        <Row className="gx-3 gy-4">
          <Col xs={12} sm={6} xl={12} className="gap-2 mb-2">

            <h5 className="mb-0 text-1000 mb-1">{t("SearchCoachSidebar.profile")}</h5>

            <Form.Check
              inline
              type='radio'
              id='item1Radio'
              label='Coach'
              defaultChecked
              name='inline-radio'
              onChange={() => setIsCoach(true)}
            />
            <Form.Check
              inline
              type='radio'
              id='item2Radio'
              label='Mentor'
              name='inline-radio'
              onChange={() => setIsCoach(false)}
            />
          </Col>
        </Row>

        {isCoach &&
          <Row className="gx-3 gy-4">
            <Col xs={12} sm={6} xl={12} className="gap-2 mb-2">
              <Form.Check
                inline
                type='radio'
                id='item1Radio2'
                label={t("SearchCoachSidebar.internal_coach")}
                defaultChecked
                name='inline-radio2'
                onChange={() => setIsCoachInterno(true)}
              />
              <Form.Check
                inline
                type='radio'
                id='item2Radio2'
                label={t("SearchCoachSidebar.external_coach")}
                name='inline-radio2'
                onChange={() => setIsCoachInterno(false)}
              />
            </Col>
          </Row>
        }

        <Row className="gx-3 gy-4">
          <Col xs={12} sm={6} xl={12}>
            <h5 className="mb-2 text-1000">{t("SearchCoachSidebar.keywords")}</h5>
            <Form.Control placeholder="Name, certification, experience, etc"
              name='keywords'
              value={searchMap.get('keywords')}
              onChange={handleInputChange}
            />
          </Col>

          <Col xs={12} sm={6} xl={12}>
            <div className="d-flex gap-2 mb-2">
              <h5 className="mb-0 text-1000">{t("SearchCoachSidebar.services")}</h5>
            </div>
            {isCoach &&
              <Form.Select aria-label="services"
                multiple={true} name="services" id="services_coach"
                onChange={handleSelectInputChange} >
                <option value="communication-skills">Communication skills</option>
                <option value="job-career-change">Job/Career change</option>
                <option value="leadership-development">Leadership development</option>
                <option value="personal-growth">Personal growth</option>
                <option value="strategic-thinking">Strategic thinking</option>
                <option value="team-effectiveness">Team effectiveness</option>
                <option value="work-life-balance">Work-life balance</option>
              </Form.Select>
            }

            {!isCoach &&
              <Form.Select aria-label="services"
                multiple={true} name="services" id="services_mentor"
                onChange={handleSelectInputChange} >
                <option value="job-career-change">Job/Career change</option>
                <option value="leadership-development">Leadership development</option>
                <option value="team-effectiveness">Team effectiveness</option>
                <option value="shadow-mentoring">Shadow mentoring</option>
              </Form.Select>
            }

          </Col>

          {isCoach &&
            <Col xs={12} sm={6} xl={12}>
              <div className="d-flex gap-2 mb-2">
                <h5 className="mb-0 text-1000">{t("SearchCoachSidebar.coaching_method")}</h5>

              </div>
              <Form.Select aria-label="coaching-method"
                multiple={true} name="coaching-method" id="coaching-method"
                onChange={handleSelectInputChange} >
                <option value="in-person">In-person</option>
                <option value="via-video-connection">Via video connection</option>
              </Form.Select>
            </Col>
          }

          {!isCoach &&
            <Col xs={12} sm={6} xl={12}>
              <div className="d-flex gap-2 mb-2">
                <h5 className="mb-0 text-1000">Held Position</h5>

              </div>
              <Form.Select aria-label="held-postion"
                multiple={true} name="held_position" id="held_position"
                onChange={handleSelectInputChange} >
                <option value="c-suite-ceo-cio-cfo">C-Suite (CEO/CIO/CFO)</option>
                <option value="learning-development">Learning Development</option>
                <option value="sales-marketing">Sales/Marketing</option>
                <option value="operation">Operation</option>
                <option value="product">Product</option>
              </Form.Select>
            </Col>
          }


          <Col xs={12} sm={6} xl={12}>
            <div className="d-flex gap-2 mb-2">
              <h5 className="mb-0 text-1000">{t("SearchCoachSidebar.location")}</h5>
            </div>
            <Form.Control placeholder="location..." className="mb-5"
              name='location'
              value={searchMap.get('location')}
              onChange={handleInputChange}
            />
          </Col>

          <Col xs={12} sm={6} xl={12}>
            <div className="d-flex gap-2 mb-2">
              <h5 className="mb-0 text-1000">Add more details about your objectives</h5>
            </div>
            <Form.Control className="mb-5"
              name='other_details'
              value={searchMap.get('other_details')}
              onChange={handleInputChange}

            />
          </Col>
        </Row>
      </Card.Body>

      <Button variant="primary" type="button" className='m-4' onClick={handleSearch}>
        Search
      </Button>
    </Card>
  );
};

export default SearchCoachSidebar;
